export const CONSTRUCTION_TAB = 1
export const REVIEW_TAB    = 2
export const EXECUTION_TAB = 3
export const HISTORY_TAB   = 4